import { GtmTrackingType } from '../constants';

class GtmRegistrationViewDelegator {
	constructor() {
		this.type = GtmTrackingType.REGISTRATION_VIEW;
	}

	getTrackingData() {
		const { pageType } = window.dataLayer[0].navigation;

		if (pageType === 'register-multi') {
			return {
				event: 'registrationView',
			};
		}
	}
}

const GtmRegistrationViewDelegatorInstance = new GtmRegistrationViewDelegator();
export default GtmRegistrationViewDelegatorInstance;

// for test purpose only
export const GtmRegistrationViewDelegatorClass = GtmRegistrationViewDelegator;
